<template>
  <div class="cadre-annonce" :class="jel_getClassObject(content)">
    <div class="annonce loterie-container w-100">
      <div class="logo-loterie">
        <b-link v-bind="jel_getLienBinding(content.lien)">
          <b-img-lazy :src="jel_getFichierSrc(content.image)" alt="" class="pr-1" />
        </b-link>

        <div v-if="isProgressifActif" class="date-tirage">
          <b-img-lazy
            v-if="isSuperTirage"
            :src="jel_getFichierSrc(content.formatJeu.image2)"
            alt="Super Tirage"
            class="super-tirage"
          />
          <div class="jour">{{ jour }}</div>
          <div class="date">{{ date }}</div>
        </div>
      </div>
      <div v-if="isProgressifActif" class="gros-lot">
        <div class="groslot-info">
          <template v-if="content.formatJeu.field === 'lotto649'">
            <div class="lotto649">
              <div class="groslot-avenir"></div>
              <div class="classique649">
                <span class="texte">{{ $i18n.tc('messageComponent.leClassique') }}</span>
                <span class="valeur">
                  {{
                    getMillions(loterie.ProchainGrosLotTirageClassique.value) +
                    ' ' +
                    $i18n.tc('messageComponent.million')
                  }}
                </span>
                <!-- <sup>*</sup> -->
              </div>
              <div class="boule-or649 groslot-boule-or">
                <div>
                  <b-img-lazy
                    :src="jel_getFichierSrc(content.formatJeu.image)"
                    alt="Boule d'or 6/49"
                    class="pr-1"
                  />
                </div>
                <div>
                  <span class="texte">{{ $i18n.tc('messageComponent.bouleDOr') }}</span
                  ><br />
                  <span class="valeur groslot-valeur">
                    {{
                      getMillions(loterie.ProchainGrosLotBouleOr.value) +
                      ' ' +
                      $i18n.tc('messageComponent.million')
                    }}<sup>*</sup>
                  </span>
                </div>
              </div>
            </div>
          </template>
          <template v-if="content.formatJeu.field === 'lottoMax'">
            <div class="lottoMax">
              <div class="groslot-avenir"></div>
              <div class="lotto-max-classique">
                {{
                  getMillions(loterie.ProchainGrosLot.value) +
                  ' ' +
                  $i18n.tc('messageComponent.million')
                }}<sup>*</sup>
              </div>
              <div class="lotto-max-plus">
                <b-img-lazy :src="jel_getFichierSrc(content.formatJeu.image)" alt="" />
                <span>
                  {{
                    loterie.NbProchainLotSupplementaire.value +
                    ' ' +
                    $i18n.tc('messageComponent.lots1Million')
                  }}
                </span>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div v-else>
        <div class="error-gros-lot text-left text-md-center">
          {{ $i18n.tc('messageComponent.error') }}
        </div>
      </div>
      <div v-if="isProgressifActif" class="mention-speciale">{{ texteMentionSpeciale }}</div>
      <div class="boutons">
        <b-link v-bind="jel_getLienBinding(content.lien)" class="acheter"
          >{{ $i18n.tc('messageComponent.acheter') }}
        </b-link>
        <b-link v-bind="jel_getLienBinding(content.lien)" class="resultats"
          >{{ $i18n.tc('messageComponent.resultats') }}
        </b-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment-timezone';
import 'moment/dist/locale/fr';
import i18n from '@/js/i18n';

import { inEditor } from '@/helpers/AppHelpers';

export default {
  name: 'CarteLoterieGrosLot',
  props: { content: { type: Object, required: true } },
  data() {
    return {
      loterie: null,
      test: null,
    };
  },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          acheter: 'Acheter',
          approx: '*Approx.',
          aujourdhui: "Aujourd'hui",
          bouleDOr: "la boule d'or",
          ce: 'Ce',
          leClassique: 'Le classique',
          lots1Million: 'Lots de 1 million',
          million: 'Million$',
          ou1Million: '*Ou 1 Million',
          resultats: 'Résultats',
          error: 'Le montant du prochain gros lot est à venir.',
        },
      },
      en: {
        messageComponent: {
          acheter: 'Buy',
          approx: '*Approx.',
          aujourdhui: 'Today',
          bouleDOr: 'The gold ball',
          ce: 'This',
          leClassique: 'The classic',
          lots1Million: 'Prizes of 1 million',
          million: 'Million',
          ou1Million: '*Or 1 Million',
          resultats: 'Results',
          error: 'The amount of the next jackpot is coming.',
        },
      },
    },
  },
  computed: {
    ...mapGetters({
      getProgressifLoterie: 'progressif/getProgressifLoterie',
      getProgressifLoterieMontant: 'progressif/getProgressifLoterieMontant',
    }),
    isSuperTirage() {
      return Math.trunc(this.loterie.NbProchainLotSupplementaire?.value) > 0;
    },
    texteMentionSpeciale() {
      if (this.content.formatJeu.field === 'lotto649') {
        return this.$i18n.t('messageComponent.ou1Million');
      }
      if (this.content.formatJeu.field === 'lottoMax') {
        return this.$i18n.t('messageComponent.approx');
      }
      return '';
    },
    jour() {
      const dateTirage = moment(this.loterie.DateProchainTirage).tz('America/Montreal', true);

      if (dateTirage.day() === moment().day()) {
        return this.$i18n.t('messageComponent.aujourdhui');
      }
      return `${this.$i18n.t('messageComponent.ce')} ${dateTirage.format('dddd')}`;
    },
    date() {
      const dateTirage = moment(this.loterie.DateProchainTirage).tz('America/Montreal', true);
      dateTirage.locale(i18n.locale);
      return `${dateTirage.day()} ${dateTirage.format('MMMM')} ${dateTirage.year()}`;
    },
    isProgressifActif() {
      if (inEditor) {
        return false;
      }
      return typeof this.loterie != 'undefined' && this.loterie != null;
    },
  },
  created() {
    moment.locale(i18n.locale);
  },
  mounted() {
    document.addEventListener('ejEventProgressifs', this.getLoterie);
  },
  beforeDestroy() {
    document.removeEventListener('ejEventProgressifs', this.getLoterie);
  },
  methods: {
    getLoterie() {
      this.loterie = this.getProgressifLoterie(this.content.formatJeu.field);
    },
    getMillions(montant) {
      return Math.trunc(montant) / 1000000;
    },
  },
};
</script>

<style lang="scss" scoped>
.cadre-annonce {
  display: flex;
  background-color: $couleur-blanc;
  text-align: center;
  width: 100%;
  height: 100%;
  max-width: 100%;
  position: relative;
  margin-right: auto;
  margin-left: auto;
  margin-bottom: 20px;
  padding: 35% 1rem 0 1rem;

  --max-size: 346.66px;

  border-bottom: 2px dotted #cccccc;
  @include media-breakpoint-up(md) {
    border: none;
    padding: unset;
    margin-bottom: unset;
    height: 31.76vw;
    width: 31.76vw;
    max-width: var(--max-size);
    max-height: var(--max-size);
  }
  @include media-breakpoint-up(lg) {
    padding: unset;
    margin-bottom: unset;
    height: 31.76vw;
    width: 31.76vw;
    max-width: var(--max-size);
    max-height: var(--max-size);
  }
  @include media-breakpoint-up(xxl) {
    padding: unset;
    margin-bottom: unset;
    height: var(--max-size);
    width: var(--max-size);
  }
}

.annonce {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

@include media-breakpoint-up(md) {
  .loterie-container {
    position: relative;
    height: 100%;
  }
}

.logo-loterie {
  position: absolute;
  width: auto;
  display: block;
  left: 3.5vw;
  @include media-breakpoint-up(md) {
    position: relative;
    left: unset;
    float: none;
    display: inline-flex;
    align-items: center;
    padding-top: 4vw;
  }
  @include media-breakpoint-up(lg) {
    float: none;
    display: inline-block;
    margin-top: 0;
  }
  @include media-breakpoint-up(xxl) {
    padding-top: 44px;
  }
  .super-tirage {
    position: relative;
    height: auto;
    width: 17vw;
    margin-left: 0.5rem;
    margin-bottom: 0.5rem;
    padding: 0;
    text-align: left;
    @include media-breakpoint-up(md) {
      margin-left: unset;
      margin-bottom: unset;
      height: auto;
      width: auto;
    }
  }

  .date-tirage {
    margin-bottom: 0.4vw;
    color: $couleur-noir;
    display: block;
    white-space: nowrap;
    font-size: 3.0666666667vw;
    text-transform: uppercase;
    .jour {
      font-family: $font-graphik-regular;
    }
    .date {
      font-family: $font-graphik-medium;
    }

    @include media-breakpoint-up(md) {
      display: inline;
      font-size: 1.98rem;
    }
    @include media-breakpoint-up(lg) {
      font-size: 2.4rem;
      margin-left: 0.5rem;
    }
    @include media-breakpoint-down(sm) {
      margin-bottom: 0.4vw;
      sup {
        top: -1.2vw;
      }
    }
    @include media-breakpoint-up(md) {
      float: none;
      display: inline-block;
      font-size: 1vw;
      line-height: 1.25vw;
      text-transform: uppercase;
      text-align: left;
    }
    @include media-breakpoint-up(xxl) {
      font-size: 12px;
      line-height: 14px;
    }
  }
  img {
    position: relative;
    padding: 6vw 1vw 1vw 1vw;
    width: 31vw;
    max-width: 100%;
    @include media-breakpoint-up(md) {
      padding: unset;
      width: auto;
      height: 6.2vw;
    }
    @include media-breakpoint-up(lg) {
      height: 74px;
    }
  }
}

.error-gros-lot {
  font-size: 4vw;
  font-family: $font-graphik-semibold;
  line-height: 4vw;
  padding: 0 16px;
  position: absolute;
  left: 67%;
  top: 25%;
  width: 67%;
  transform: translate(-50%, 0%);

  @include media-breakpoint-up(md) {
    font-size: 1.1rem;
    line-height: 1.1rem;
    top: 50%;
    left: 50%;
    transform: translate(-50%, 0%);
    width: 100%;
  }
  @include media-breakpoint-up(lg) {
    font-size: 20px;
    line-height: 20px;
  }
}

.gros-lot {
  display: flex;
  align-items: center;
  height: 100%;
  font-family: $font-graphik-bold;
  text-transform: uppercase;
  @include media-breakpoint-up(md) {
    height: 40%;
  }
  @include media-breakpoint-up(lg) {
    height: 110px;
  }
  .groslot-info {
    float: none;
    position: absolute;
    top: 38%;
    left: 68%;
    height: auto;
    transform: translate(-50%, -50%);
    width: 60vw;
    padding-bottom: 1.5rem;
    text-align: left;
    overflow: visible;
    @include media-breakpoint-up(md) {
      position: relative;
      left: unset;
      top: 12px;
      transform: unset;
      width: 100%;
      text-align: center;
    }
  }
}

.groslot-avenir {
  display: none;
  width: 60vw;
  font-family: $font-graphik-semibold;
  color: $couleur-noir;
  font-size: 4vw;
  line-height: 4.9vw;
  margin-left: 5vw;
  padding-right: 4vw;
  text-transform: none;
  @include media-breakpoint-down(sm) {
    margin-left: auto;
  }
  @include media-breakpoint-up(md) {
    width: 100%;
    padding: 0 15px;
    margin: 0;
    text-align: center;
    font-size: 2vw;
    line-height: 2.5vw;
  }
  @include media-breakpoint-up(lg) {
    font-size: 1.8rem;
    line-height: 1.33;
    padding: 0 40px;
  }
}
.groslot-plus {
  color: $couleur-groslot-plus;
  font-family: $font-graphik-semibold;
  white-space: nowrap;
  font-size: 4.1333333333vw;
  margin-top: 0.28rem;
  line-height: 4.8vw;
}

.lotto-max-classique {
  color: $couleur-lottomax-classique;
  font-size: 6.13333vw;
  font-family: $font-graphik-semibold;
  line-height: 6.1333333333vw;
  margin-top: 0.1333333333vw;
  white-space: nowrap;
  display: inline-block;

  @include media-breakpoint-down(sm) {
    font-size: 6.13333vw;
    margin-top: 1vw;
    margin-bottom: 1vw;
  }
  @include media-breakpoint-up(md) {
    font-size: 3.73333vw;
    line-height: 1.92rem;
    text-align: center;
    margin-left: unset;
    top: unset;
  }
  @include media-breakpoint-up(lg) {
    font-size: 3.2vw;
    line-height: 2rem;
    margin-top: 1rem;
  }
  @include media-breakpoint-up(xl) {
    font-size: 40px;
  }
}
.lotto-max-plus {
  display: flex;
  align-items: center;
  color: $couleur-lottomax-plus;
  font-size: 4.1333333333vw;
  font-family: $font-graphik-regular;
  line-height: 4.8vw;
  text-align: center;
  white-space: nowrap;
  @include media-breakpoint-up(md) {
    justify-content: center;
    margin-bottom: 0.8vw;
    font-size: 1.86667vw;
    line-height: 2.16rem;
  }
  @include media-breakpoint-up(xl) {
    font-size: 24px;
  }
  img {
    height: 5vw;
    @include media-breakpoint-up(md) {
      height: 2vw;
    }
    @include media-breakpoint-up(lg) {
      height: 2vw;
    }
  }
}

.classique649 {
  color: $couleur-classique-649;
  text-align: left;
  white-space: nowrap;
  @include media-breakpoint-up(md) {
    padding-bottom: 1rem;
    text-align: center;
  }
  .texte {
    font-size: 2.1333333333vw;
    font-family: $font-graphik-semibold;
    @include media-breakpoint-up(md) {
      font-size: 10px;
    }
    @include media-breakpoint-up(lg) {
      font-size: 14px;
    }
  }
  .valeur {
    font-size: 3.1333333333vw;
    line-height: 1.5rem;
    font-family: $font-graphik-bold;
    @include media-breakpoint-up(md) {
      font-size: 18px;
    }
    @include media-breakpoint-up(lg) {
      font-size: 20px;
    }
  }
  sup {
    font-size: 2.1333333333vw;
    text-align: left;
    @include media-breakpoint-up(md) {
      font-size: 1vw;
    }
    @include media-breakpoint-up(lg) {
      font-size: 12px;
    }
  }
}
.boule-or649 {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: $font-graphik-medium;
  line-height: 1rem;
  text-align: left;
  @include media-breakpoint-up(md) {
    justify-content: center;
    line-height: 1rem;
  }
  .texte {
    color: $couleur-boule-or649-texte;
    font-size: 2.7333333333vw;
    @include media-breakpoint-up(md) {
      font-size: 0.9rem;
    }
    @include media-breakpoint-up(lg) {
      font-size: 1.2rem;
    }
  }
  .valeur {
    color: $couleur-boule-or649-valeur;
    font-size: 6.13333vw;
    @include media-breakpoint-up(md) {
      font-size: 3.125vw;
    }
    @include media-breakpoint-up(lg) {
      font-size: 2.4rem;
    }
  }
  img {
    height: 7vw;
    max-width: 10vw;
    margin-right: 0.5rem;
    vertical-align: middle;
    @include media-breakpoint-up(md) {
      height: 4.5vw;
      max-width: 3.8rem;
      margin-right: 0.4rem;
    }
    @include media-breakpoint-up(lg) {
      height: 3rem;
      max-width: 4.6rem;
      margin-right: 0.5rem;
    }
  }
}

.mention-speciale {
  display: flex;
  font-size: 10px;
  font-family: $font-graphik-regular;
  position: absolute;
  bottom: 3vw;
  right: 4vw;
  text-transform: uppercase;
  @include media-breakpoint-up(md) {
    position: relative;
    bottom: unset;
    right: unset;
    left: unset;
    font-size: 7px;
    padding-bottom: 0.25rem;
    justify-content: center;
  }
  @include media-breakpoint-up(lg) {
    font-size: 10px;
    padding-bottom: 12px;
  }
  @include media-breakpoint-up(xl) {
    padding-bottom: 12px;
  }
}

.boutons {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 10%;
  left: 50%;
  transform: translateX(-50%);
  font-family: $font-graphik-regular;
  text-transform: uppercase;
  z-index: 9999;
  @include media-breakpoint-up(md) {
    bottom: 0.5vw;
    width: 100%;
  }
  @include media-breakpoint-up(lg) {
    bottom: 29px;
    width: 100%;
  }
  .acheter,
  .resultats {
    text-decoration: none;
    border-radius: 8px;
    margin: 6px;
    font-size: 3.46667vw;
    line-height: 1.25em;
    padding: 3.06667vw 5.2vw 3.33333vw;
    @include media-breakpoint-up(md) {
      text-decoration: none;
      border-radius: 8px;
      margin: 6px;
      padding: 6px 16px;
      font-size: 1.33333vw;
    }
    @include media-breakpoint-up(lg) {
      font-size: 1.06667vw;
      padding: 9px 25px;
    }
    @include media-breakpoint-up(xl) {
      font-size: 0.8rem;
      padding: 9px 25px;
    }
  }
  .resultats {
    display: none;
    @include media-breakpoint-up(md) {
      display: block;
    }
  }
  .acheter {
    background-color: $couleur-rouge;
    border: 2px solid $couleur-rouge;
    color: $couleur-blanc;
    &:hover {
      background-color: transparent !important;
      color: $couleur-rouge;
    }
  }
  .resultats {
    background-color: $couleur-bouton-resultats;
    border: 2px solid $couleur-bouton-resultats;
    color: $couleur-blanc;
    &:hover {
      background-color: transparent !important;
      color: $couleur-bouton-resultats;
    }
  }
}

.groslot-valeur {
  font-weight: 720;
  line-height: 6.1333333333vw;
  margin-top: 0.1333333333vw;
  white-space: nowrap;

  @include media-breakpoint-down(sm) {
    font-size: 6.13333vw;
    margin-top: 1vw;
    margin-bottom: 1vw;
  }
  @include media-breakpoint-up(md) {
    font-size: 3.73333vw;
    line-height: 1.92rem;
    text-align: center;
  }
  @include media-breakpoint-up(lg) {
    font-size: 3.2vw;
    line-height: 2rem;
    margin-top: 1rem;
  }
  @include media-breakpoint-up(xxl) {
    font-size: 4rem;
  }
}
.groslot-plus {
  font-family: $font-graphik-medium;
  white-space: nowrap;
  font-size: 4.1333333333vw;
  margin-top: 0.28rem;
  line-height: 4.8vw;

  @include media-breakpoint-up(md) {
    text-align: center;
    font-size: 1.86667vw;
    margin-top: 0.8vw;
    line-height: 2.16rem;
  }
  @include media-breakpoint-up(lg) {
    font-size: 1.73333vw;
    line-height: 2.6rem;
    margin-top: 0.35vw;
  }
  @include media-breakpoint-up(xxl) {
    font-size: 2rem;
    margin-top: 0.6rem;
  }
}
</style>
